export class ContactEmploymentMeta {
  branch?: string;
  armyId?: string;

  constructor(model: Partial<ContactEmploymentMeta> = {}) {
    this.armyId = model.armyId;
    this.branch = model.branch;
  }
}
